import "./ProductCard.css";
import {Link} from "react-router-dom";
import {useEffect, useState} from "react";
import {SyncLoader} from "react-spinners";
import NoImage from "../../images/NoImage.jpg"

export default function ProductCard(product) {

    const [image, setImage] = useState();

    useEffect(() => {
        if(product.product.variants) {
            fetch(`/backend/${product.product.variants[0].imageFolder}/1.jpg`, { cache: "no-cache" })
                .then(response => {
                    return response.blob();
                })
                .then(blob => {
                    const imageUrl = URL.createObjectURL(blob);
                    if(blob.type === 'text/html')
                        setImage(NoImage);
                    else
                        setImage(imageUrl);
                })
        }
        else {
            fetch(`/backend/${product.product.imageFolder}/1.jpg`, { cache: "no-cache" })
                .then(response => {
                    return response.blob();
                })
                .then(blob => {
                    const imageUrl = URL.createObjectURL(blob);
                    if(blob.type === 'text/html')
                        setImage(NoImage);
                    else
                        setImage(imageUrl);
                })
        }
    }, []);

    return (
        <div id="ProductContainer">
            {image ?
                <Link id="ProductInfo" to={`/product/${product.product.id}`}>
                    <img id="ProductImage" src={image} alt="FotoProdotto"/>
                    <div id="ProductName">
                        {product.product.name}
                    </div>

                </Link> :
                <SyncLoader
                    className="dotLoader"
                    color="#000000"
                    size={12}
                />
            }
        </div>
    )
}